import { Link, useLocation } from "react-router-dom";
import SVGForPage from "./SVGForPage";
import { useAppSelector } from "src/app/hooks";
import { selectAuth } from "src/features/authSlice";

const HelpButton = () => {
  const location = useLocation();
  const isHelpActive = location.pathname.startsWith("/help");
  const { isEmailVerified, isNXXG } = useAppSelector(selectAuth);

  const handleDropdownItemClick = () => {
    const dropdownElement = document.querySelector(".dropdown-menu.show");
    if (dropdownElement) {
      dropdownElement.classList.remove("show");
    }
    const dropdownToggle = document.querySelector(
      '[data-bs-toggle="dropdown"][aria-expanded="true"]',
    );
    if (dropdownToggle) {
      dropdownToggle.setAttribute("aria-expanded", "false");
    }
  };

  return (
    <li className="nav-item dropdown">
      <Link
        className={`nav-link dropdown-toggle ${isHelpActive ? "underline-navbar-item" : ""}`}
        to="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={(e) => e.preventDefault()}
      >
        <i className="bi bi-question-circle pe-2"></i>Help
      </Link>
      <ul className="dropdown-menu">
        <li className="nav-item">
          <Link
            className="dropdown-item"
            to="/help/new"
            onClick={handleDropdownItemClick}
          >
            <SVGForPage pageKeyword="help-new" />
            Create New Ticket
          </Link>
        </li>
        <li
          className={`nav-item ${!isEmailVerified || isNXXG ? "d-none" : ""}`}
        >
          <Link
            className="dropdown-item"
            to="/help/tickets"
            onClick={handleDropdownItemClick}
          >
            <SVGForPage pageKeyword="help-tickets" />
            My Tickets
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="dropdown-item"
            to="/help/docs"
            onClick={handleDropdownItemClick}
          >
            <SVGForPage pageKeyword="help-docs" />
            Documentation
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default HelpButton;
